<header class="header">
	<flex-privacy-policy-navbar></flex-privacy-policy-navbar>
	<div class="header__container">
		<dsy-heading class="header__title" level="h2" level-size="5xl" level-style="bold">
			Privacy Policy
		</dsy-heading>

		<div class="header__lang">
			<flex-privacy-policy-language-selector></flex-privacy-policy-language-selector>
		</div>
	</div>
</header>